// Gold 🟡 (Economy v0.1, п. 21–26): редкая валюта. Claimable — может пойти в сезон токена (фазы 3–4),
// bonus — только внутри игры. Claimable не продаётся ни за Stars, ни за деньги.

export const GOLD = {
  /** обмен: столько серебра за 1 Gold */
  silverRate: 1000,
  /** не больше стольких Gold обменом в сутки (с 00:00 МСК) */
  exchangePerDay: 1,
  /** чемпиону публичного турнира: claimable, если все участники люди, иначе bonus */
  champion: { 4: 1, 8: 2 } as Record<number, number>,
} as const;

export interface GoldBalanceDto {
  claimable: number;
  bonus: number;
  /** вложено в сезон (фаза 3) */
  committed: number;
}

/** GET /api/economy/balance */
export interface EconomyBalanceDto {
  silver: number;
  gold: GoldBalanceDto;
  tickets: import('./tickets.js').TicketsDto;
  /** сколько Gold ещё можно получить обменом сегодня */
  exchangeLeftToday: number;
}

/** POST /api/economy/exchange/silver-gold */
export interface SilverGoldExchangeResponse {
  silverSpent: number;
  goldReceived: number;
  silverBalance: number;
  goldBalance: number;
  dailyGoldRemaining: number;
}
